/* eslint-disable import/prefer-default-export */
/**
 * Resolves the weekly usage target (in minutes) for a student's grade from the content-api bands.
 * A grade with no band is an expected runtime state rather than a programming error:
 * every failure mode resolves to null.
 * @param {Array<{ grades: string[], targets: { weeklyTargetHigh: number } }>} usageTargets - Bands from the API
 * @param {string} grade - The student's grade code (e.g. 'KG', '03')
 * @returns {number|null} The target in minutes, or null when no usable target exists for the grade
 */
export const getWeeklyTarget = (usageTargets, grade) => {
  if (!Array.isArray(usageTargets) || !grade) {
    return null;
  }

  // every grade appears in at most one band, so the first match is the only match.
  const band = usageTargets.find(({ grades } = {}) => Array.isArray(grades) && grades.includes(grade));

  if (!band) {
    return null;
  }

  const target = band.targets?.weeklyTargetHigh;

  if (!Number.isFinite(target) || target <= 0) {
    return null;
  }

  return target;
};
